import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'outline-btn-loading',
  template: `
    <button matRipple class="{{ btnClass }} disabled:opacity-75 border rounded" [type]="type" 
    [disabled]="loading || formValid || btnDisabled" [ngClass]="{ loading: loading }">
    <mat-icon class="bx bx-loader icon-size-[13px] bx-spin text-md align-middle leading-none" *ngIf="loading">
    </mat-icon>
    <span *ngIf="!loading" class="flex items-center justify-center">
        <ng-content></ng-content>
    </span>
    <span class="ml-2" *ngIf="loading">{{ loadingText }} </span>
    </button>
  `,
  styleUrls: ['./btn.scss'],
  styles: [`
    
  `]
})
export class OutlineBtnLoadingComponent implements OnInit {
  @Input("loading") loading: boolean;
  @Input("btnClass") btnClass: string;
  @Input("loadingText") loadingText = "Please wait";
  @Input("type") type: "button" | "submit" = "submit";
  @Input("formValid") formValid: boolean = false;
  @Input("btnDisabled") btnDisabled: boolean = false;
  @Input("color") color = 'primary';

  constructor() { }
  
  ngOnInit(): void {
    
  }
}
